export default {
  rotateEnabled: false,
};
